import React from 'react'
import styles from './index.module.less'
import classnames from 'classnames'

import { IWorth, IState } from '@/components/poizon-fission/types'

const Money = (props: Pick<IWorth, 'currencySign' | 'sum' | 'isDiscount'>) => {
  const { currencySign, sum, isDiscount = true } = props
  return (
    <>
      <span className={styles.currency}>{currencySign}</span>
      <span className={styles.sum}>{sum}</span>
      {isDiscount && <span className={styles.discount}>OFF</span>}
    </>
  )
}

const Percent = (props: Pick<IWorth, 'sum'>) => {
  const { sum } = props
  return (
    <>
      <span className={styles.currency} />
      <span className={styles.sum}>{sum}%</span>
    </>
  )
}

export default function Worth(props: IWorth & IState) {
  const { flow, type = 'money', currencySign, sum, explain, isDiscount } = props
  return (
    <div className={styles.coupon}>
      <div className={classnames(styles.worth, styles[flow])}>
        {type === 'money' ? (
          <Money currencySign={currencySign} sum={sum} isDiscount={isDiscount} />
        ) : (
          <Percent sum={sum} />
        )}
      </div>
      <div className={classnames(styles.explain, styles[flow])}>{explain}</div>
    </div>
  )
}
